module.exports = __webpack_public_path__ + "img/logo-blue.0a5bb9f1.svg";